export const enum PageId {
	Homepage = 'Homepage',
	ActiveEvent1 = 'ActiveEvent1',
	ActiveEvent2 = 'ActiveEvent2',
	AboutUs = 'AboutUs',
	MissionVision = 'MissionVision',
	BoardOfAdvisors = 'BoardOfAdvisors',
	ExecutiveCouncil = 'ExecutiveCouncil',
	IndustrialExpertAdvisory = 'IndustrialExpertAdvisory',
	TAAConstitution = 'TAAConstitution',
	Events = 'Events',
	EventsGallery = 'EventsGallery',
	Video = 'Video',
	Homecoming = 'Homecoming',
	News = 'News',
	CallToReform = 'CallToReform',
	TAAEducationTrust = 'TAAEducationTrust',
	NewsRelease = 'NewsRelease',
	NewsClippings = 'NewsClippings',
	AlumniNewsClippings = 'AlumniNewsClippings',
	AGM = 'AGM',
	AuditedReport = 'AuditedReport',
	Membership = 'Membership',
	JoinUs = 'JoinUs',
	TAAPrivacyPolicy = 'TAAPrivacyPolicy',
	TCCI = 'TCCI',
	TARUCTAAScholarships = 'TARUCTAAScholarships',
	RegionalCharter = 'RegionalCharter',
	SouthCharter = 'SouthCharter',
	ContactUs = 'ContactUs',
	Donation = 'Donation',
	COTBook = 'COTBook',
}

export const enum OutsourceLink {
	TARCianRunGoogleForm = 'https://docs.google.com/forms/d/e/1FAIpQLSeJhUI1Mk90iHyYuh1xobj3Ptvbuxnpz1I1x0KaP2Ewf4NZrQ/closedform',
	MembershipApplicationForm = '/join-us',
	EventPageVideo = 'https://www.youtube.com/watch?v=z-6GiDc8TDs',
	DonationGoogleForm = 'https://docs.google.com/forms/d/e/1FAIpQLScdFvwWqjmZHaEj-_SXv73hR8Kxa6IaHeDZeevfAy4z-4VY6A/viewform?embedded=true',
}
